import React, { useState, useEffect } from 'react';
import { Container, Row, Col } from 'react-bootstrap';
import { useFragment } from 'react-relay';
import { graphql } from 'babel-plugin-relay/macro';
import LinkButton from '../../uikit/Links/LinkButton';
import type { NotFound$key } from './__generated__/NotFound.graphql';

import './ErrorPage.sass';
import Animation from '../../assets/img/404/animation-dudes-principle.gif';

interface Props {
	query: NotFound$key;
	type: string;
}

function NotFound({ query, type }: Props) {
	const [content, setContent] = useState<{
		title: string;
		subtitle: string;
		text: string;
		button: {
			target: string;
			url: string;
			name: string;
		}[];
		errorCode: string;
	}>();

	// eslint-disable-next-line @typescript-eslint/no-explicit-any
	const data: any = useFragment(
		graphql`
			fragment NotFound on ErrorPagePublishedContentConnection {
				items {
					title
					subtitle
					text
					errorCode
					button {
						name
						url
						target
					}
				}
			}
		`,
		query
	);
	useEffect(() => {
		if (data) {
			data.items.map(
				(item: {
					title: string;
					subtitle: string;
					text: string;
					button: { target: string; url: string; name: string }[];
					errorCode: string;
				}) => {
					if (item.errorCode === type) {
						setContent(item);
					}
				}
			);
		}
	}, [data]);

	return (
		<div className="error-page">
			<Container>
				<Row>
					<Col
						xs={12}
						md={7}
						lg={{ offset: 1, span: 5 }}
						className="error-page__content"
					>
						{content?.title && (
							<h2 className="uikit-label-small-caps">{content.title}</h2>
						)}
						{content?.subtitle && (
							<h3 className="uikit-heading-lg error-page__heading">
								{content?.subtitle}
							</h3>
						)}
						{content?.text && (
							<p className="uikit-text-regular error-page__description">
								{content.text}
							</p>
						)}
						{content?.button && (
							<div className="error-page__button">
								<LinkButton
									hrefSource={content.button[0].url}
									label={content.button[0].name}
									isOrange
									isExternal={content.button[0].target === '_blank'}
								/>
							</div>
						)}
					</Col>
					<Col
						xs={12}
						md={5}
						lg={{ offset: 1, span: 5 }}
						xl={4}
						className="error-page__sidebar"
					>
						<div className="error-page__sidebar-inner">
							<img
								className="error-page__animation"
								src={Animation}
								alt="dudes"
							/>
						</div>
					</Col>
				</Row>
			</Container>
		</div>
	);
}

export default NotFound;
